import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { CLINIC } from "../lib/api";
import AppointmentForm from "../components/AppointmentForm";

export default function Contacto() {
  return (
    <div data-testid="contacto-page">
      <section className="py-20 bg-gradient-to-b from-teal-50/60 to-white">
        <div className="container-max">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 bg-white border border-slate-200 rounded-full px-4 py-1.5 mb-6">
              <span className="text-xs font-semibold text-teal-700 uppercase">Contacto</span>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
              Pide tu <span className="underline-accent">primera visita gratuita</span>
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Rellena el formulario y te contactamos en menos de 24h para confirmar tu cita.
              También puedes llamarnos o escribirnos por WhatsApp.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container-max">
          <div className="grid lg:grid-cols-5 gap-10">
            <div className="lg:col-span-3 bg-white rounded-3xl p-6 md:p-10 border border-slate-200 shadow-sm">
              <h2 className="text-2xl font-bold text-slate-900 mb-2">Reserva tu cita online</h2>
              <p className="text-sm text-slate-600 mb-6">Respuesta en menos de 24 horas</p>
              <AppointmentForm />
            </div>

            <div className="lg:col-span-2 space-y-5">
              <div className="bg-teal-50 rounded-3xl p-6">
                <h3 className="font-bold text-slate-900 mb-5 text-lg">Datos de contacto</h3>
                <ul className="space-y-4">
                  <li className="flex gap-3 items-start">
                    <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0">
                      <MapPin className="w-4 h-4 text-teal-700" />
                    </div>
                    <div>
                      <div className="text-xs font-semibold text-slate-500 uppercase mb-1">Dirección</div>
                      <div className="text-sm text-slate-800">
                        {CLINIC.address}<br />{CLINIC.city}
                      </div>
                    </div>
                  </li>
                  <li className="flex gap-3 items-start">
                    <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0">
                      <Phone className="w-4 h-4 text-teal-700" />
                    </div>
                    <div>
                      <div className="text-xs font-semibold text-slate-500 uppercase mb-1">Teléfono</div>
                      <a href={`tel:${CLINIC.phone}`} data-testid="contact-phone" className="text-sm text-slate-800 hover:text-teal-700">
                        {CLINIC.phoneDisplay}
                      </a>
                    </div>
                  </li>
                  <li className="flex gap-3 items-start">
                    <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0">
                      <Mail className="w-4 h-4 text-teal-700" />
                    </div>
                    <div>
                      <div className="text-xs font-semibold text-slate-500 uppercase mb-1">Email</div>
                      <a href={`mailto:${CLINIC.email}`} data-testid="contact-email" className="text-sm text-slate-800 hover:text-teal-700 break-all">
                        {CLINIC.email}
                      </a>
                    </div>
                  </li>
                  <li className="flex gap-3 items-start">
                    <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0">
                      <Clock className="w-4 h-4 text-teal-700" />
                    </div>
                    <div className="flex-1">
                      <div className="text-xs font-semibold text-slate-500 uppercase mb-1">Horario</div>
                      <ul className="text-sm text-slate-800 space-y-1">
                        {CLINIC.hours.map((h) => (
                          <li key={h.day} className="flex justify-between gap-3">
                            <span className="font-medium">{h.day}</span>
                            <span className="text-slate-600 text-xs">{h.time}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden">
                <iframe
                  title="Mapa Clínica Dental Pina"
                  src="https://maps.google.com/maps?q=Vilamar+70+Calafell+Platja&t=&z=15&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  data-testid="contact-map"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
